import { ReactNode } from "react";
import TYPE_RESSOURCE from "../../enum/TypeRessource.tsx";
import RessourceByCode from "../Ressource/RessourceByCode.tsx";
import Modal from "./Modal.tsx";

const PreviewRessourceModal = ({
  visible,
  closeModal,
  header,
  ressourceCode,
  ressourceType,
  ressourcePrivee,
}: PreviewRessourceModalType) => {
  return (
    <Modal closeModal={closeModal} header={header} visible={visible}>
      <div>
        <RessourceByCode
          code={ressourceCode}
          type={ressourceType}
          prive={ressourcePrivee}
        />
      </div>
    </Modal>
  );
};
type PreviewRessourceModalType = {
  visible: boolean;
  header?: ReactNode | undefined;
  closeModal: () => boolean;
  ressourceCode: string;
  ressourceType: TYPE_RESSOURCE;
  ressourcePrivee: boolean;
};

export default PreviewRessourceModal;
